import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const { setUser, API } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const sid = new URLSearchParams(hash.replace('#', '')).get('session_id');
    if (!sid) { navigate('/login'); return; }

    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: 'POST', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sid }),
        });
        if (res.status === 403) { setError('domain'); return; }
        if (!res.ok) { setError('generic'); return; }
        const u = await res.json();
        setUser(u);
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { state: { user: u }, replace: true });
      } catch {
        setError('generic');
      }
    })();
  }, [API, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(222,47%,11%)] text-slate-100 p-6">
      {!error ? (
        <div className="text-center">
          <div className="w-12 h-12 mx-auto rounded-sm border-2 border-sky-400 flex items-center justify-center font-black animate-pulse">MOC</div>
          <p className="mt-4 text-sm text-slate-400">Connexion en cours…</p>
        </div>
      ) : (
        <div className="max-w-md text-center">
          <h1 className="font-display text-2xl font-bold text-red-400">Accès refusé</h1>
          <p className="mt-3 text-slate-400 text-sm">
            {error === 'domain'
              ? "Votre compte n'appartient pas à un domaine autorisé (@lafarge.com, @geocycle.com). Contactez l'administrateur MOC."
              : "Une erreur est survenue lors de la connexion. Veuillez réessayer."}
          </p>
          <button data-testid="callback-retry" onClick={() => (window.location.href = '/login')}
            className="mt-6 px-4 py-2 rounded-sm bg-white text-slate-900 text-sm font-semibold">
            Retour à la connexion
          </button>
        </div>
      )}
    </div>
  );
}
